'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_Store(id_$_lo, id_$_hi, account, name, favorite, deleted) {
  this.nX = 0;
  this.nY = 0;
  this.zm = null;
  this.sN = null;
  this.wF = false;
  this.zn = false;
  this.nX = id_$_lo;
  this.nY = id_$_hi;
  this.zm = account;
  this.sN = name;
  this.wF = favorite;
  this.zn = deleted;
}
export { $c_Lmealorama_Store as $c_Lmealorama_Store };
$p = $c_Lmealorama_Store.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Store;
/** @constructor */
function $h_Lmealorama_Store() {
}
export { $h_Lmealorama_Store as $h_Lmealorama_Store };
$h_Lmealorama_Store.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 80218305);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.nX, this.nY)));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.zm));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.sN));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.wF ? 1231 : 1237));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (this.zn ? 1231 : 1237));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 5);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_Store)) {
    if (((this.wF === x$0.wF) && (this.zn === x$0.zn))) {
      var x_$_lo = this.nX;
      var x_$_hi = this.nY;
      var $x_3 = x$0;
      var x$1_$_lo = $x_3.nX;
      var x$1_$_hi = $x_3.nY;
      var $x_2 = (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$2 = this.zm;
      var x$2$1 = x$0.zm;
      var $x_1 = ((x$2 === null) ? (x$2$1 === null) : x$2.f(x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      return (this.sN === x$0.sN);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 5;
});
$p.r = (function() {
  return "Store";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.nX, this.nY);
      break;
    }
    case 1: {
      return this.zm;
      break;
    }
    case 2: {
      return this.sN;
      break;
    }
    case 3: {
      return this.wF;
      break;
    }
    case 4: {
      return this.zn;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_Store(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jX)));
}
export { $isArrayOf_Lmealorama_Store as $isArrayOf_Lmealorama_Store };
var $d_Lmealorama_Store = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Store, "mealorama.Store", ({
  jX: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_Store as $d_Lmealorama_Store };
//# sourceMappingURL=mealorama.-Store.js.map
